{
  "appTitle": "BACK OFFICE",
  "changelog": {
    "title": "Lista zmian",
    "description": "Co nowego w Back Office"
  },
  "errors": {
    "loadFailed": "Nie udało się załadować szczegółów."
  },
  "accessDenied": {
    "title": "Brak dostępu",
    "description": "Nie masz uprawnień do wyświetlenia tej strony.",
    "missingPermission": "Brakujące uprawnienie: {{permission}}",
    "backToHome": "Wróć"
  },
  "noAccess": {
    "title": "Brak dostępu",
    "description": "Twoje konto nie ma uprawnień do korzystania z backoffice.",
    "hint": "Skontaktuj się z administratorem, aby poprosić o dostęp.",
    "signedInAs": "Zalogowano jako {{email}}",
    "signOut": "Wyloguj"
  },
  "nav": {
    "management": "Zarządzanie",
    "iam": "Tożsamość i dostęp",
    "ingress": "Import danych",
    "octo": "Octo",
    "hardware": "Sprzęt"
  },
  "home": {
    "title": "Strona główna"
  },
  "users": {
    "tools": {
      "menuLabel": "Narzędzia",
      "lastLogin": "Rozkład ostatnich logowań"
    },
    "lastLoginChart": {
      "title": "Rozkład ostatnich logowań",
      "description": "Kiedy użytkownicy pasujący do bieżącego filtra logowali się ostatnio.",
      "empty": "Brak aktywności logowania dla bieżącego wyboru.",
      "neverNote": "Nigdy nie zalogowano: {{count}}",
      "tooltipTotal": "Łącznie"
    },
    "title": "Użytkownicy",
    "list": {
      "columns": {
        "id": "ID",
        "publicId": "Publiczne ID",
        "userName": "Nazwa użytkownika",
        "email": "E-mail",
        "fullName": "Imię i nazwisko",
        "realm": "Domena",
        "defaultStore": "Domyślny sklep",
        "mfa": "MFA",
        "lastLoginAt": "Ostatnie logowanie",
        "lastAttemptAt": "Ostatnia próba",
        "status": "Status",
        "createdAt": "Utworzono"
      },
      "actions": {
        "activate": "Aktywuj",
        "deactivate": "Dezaktywuj",
        "changeStore": "Zmień sklep",
        "delete": "Usuń użytkownika",
        "cannotModifySelf": "Nie możesz dezaktywować ani usunąć własnego konta"
      },
      "addUserButton": "Utwórz użytkownika",
      "searchPlaceholder": "Szukaj użytkowników...",
      "filter": {
        "realm": "Domena",
        "searchRealms": "Szukaj domen…",
        "noRealms": "Nie znaleziono domen",
        "chain": "Sieć",
        "searchChains": "Szukaj sieci…",
        "noChains": "Nie znaleziono sieci",
        "store": "Sklep",
        "searchStores": "Szukaj sklepów…",
        "noStores": "Nie znaleziono sklepów"
      }
    },
    "dialog": {
      "createTitle": "Utwórz użytkownika",
      "comingSoon": "Wkrótce",
      "deactivateTitle": "Dezaktywuj użytkownika",
      "activateTitle": "Aktywuj użytkownika",
      "deactivatePrompt": "Czy na pewno chcesz dezaktywować",
      "activatePrompt": "Czy na pewno chcesz aktywować",
      "deactivateWarning": "Ten użytkownik natychmiast utraci dostęp do focalOS.",
      "deactivateConfirm": "Dezaktywuj",
      "activateConfirm": "Aktywuj"
    },
    "deleteDialog": {
      "title": "Usuń użytkownika",
      "prompt": "Czy na pewno chcesz trwale usunąć",
      "warning": "Ta operacja jest nieodwracalna.",
      "confirm": "Usuń"
    },
    "changeStoreDialog": {
      "title": "Zmień domyślny sklep",
      "description": "Wybierz nowy domyślny sklep dla",
      "storeLabel": "Domyślny sklep",
      "selectStore": "Wybierz sklep",
      "searchStores": "Szukaj sklepów…",
      "noStores": "Nie znaleziono sklepów",
      "removePrevious": "Usuń poprzedni domyślny sklep z dostępnych sklepów",
      "save": "Zapisz"
    },
    "form": {
      "email": "E-mail",
      "username": "Nazwa użytkownika",
      "fullName": "Imię i nazwisko",
      "realm": "Domena",
      "selectRealm": "Wybierz domenę",
      "searchRealms": "Szukaj domen…",
      "noRealms": "Nie znaleziono domen",
      "realmChangeWarning": "Zmiana domeny SSO usunie hasło użytkownika z bazy danych; przywrócenie oryginalnego hasła będzie niemożliwe.",
      "notRequired": "Niewymagane",
      "password": "Hasło",
      "passwordEditPlaceholder": "Pozostaw puste, aby zachować obecne",
      "validationDisabled": "Walidacja wyłączona",
      "validationDisabledHint": "Członkowie grupy admin mogą ustawiać hasła bez wymagań złożoności",
      "groups": "Grupy",
      "selectGroups": "Wybierz grupy",
      "searchGroups": "Szukaj grup…",
      "noGroups": "Nie znaleziono grup",
      "defaultStore": "Domyślny sklep",
      "selectStore": "Wybierz sklep",
      "searchStores": "Szukaj sklepów…",
      "noStores": "Nie znaleziono sklepów",
      "availableStores": "Dostępne sklepy",
      "selectAvailableStores": "Wybierz sklepy",
      "validation": {
        "required": "Wymagane",
        "invalidEmail": "Musi być prawidłowy adres e-mail",
        "passwordMinLength": "Hasło musi mieć co najmniej 8 znaków",
        "emailExists": "Użytkownik z tym adresem e-mail już istnieje",
        "usernameExists": "Użytkownik o tej nazwie użytkownika już istnieje"
      },
      "ftFueTraining": "Szkolenie FT FUE",
      "requirePasswordReset": "Wymagaj resetu hasła",
      "flags": "Flagi",
      "selectFlags": "Wybierz flagi",
      "searchFlags": "Szukaj flag…",
      "noFlags": "Nie znaleziono flag",
      "supervisor": "Przełożony",
      "selectSupervisor": "Wybierz przełożonego",
      "searchSupervisor": "Szukaj osób…",
      "noSupervisor": "Nie znaleziono osób"
    },
    "detail": {
      "profileTitle": "Profil",
      "fullName": "Imię i nazwisko",
      "groupsTitle": "Grupy",
      "permissionsTitle": "Uprawnienia",
      "directlyAssigned": "Przypisane bezpośrednio",
      "availableStores": "Dostępne sklepy"
    },
    "notifications": {
      "activated": "Użytkownik \"{{name}}\" aktywowany",
      "deactivated": "Użytkownik \"{{name}}\" dezaktywowany",
      "created": "Użytkownik \"{{name}}\" utworzony",
      "updated": "Użytkownik \"{{name}}\" zaktualizowany",
      "deleted": "Użytkownik \"{{name}}\" usunięty",
      "createFailed": "Nie udało się utworzyć użytkownika"
    },
    "permissions": {
      "view": "Podgląd",
      "edit": "Edycja",
      "fullAccess": "Pełny dostęp",
      "everyBackofficePermission": "Każde uprawnienie backoffice",
      "everyPermission": "Każde uprawnienie (superużytkownik)",
      "allPermissions": "Wszystkie uprawnienia {{section}}",
      "grantedVia": "Przyznane przez {{permission}}",
      "inheritedFromGroup": "Odziedziczone z grupy „{{group}}”",
      "inheritBanner": {
        "prefix": "Ten użytkownik dziedziczy uprawnienia z",
        "suffix": "Odziedziczone uprawnienia są wyświetlane jako zablokowane i nie można ich tutaj zmienić."
      },
      "labels": {
        "approvals": "Zatwierdzenia",
        "chains": "Sieci",
        "regions": "Regiony",
        "settings": "Ustawienia",
        "activity": "Aktywność",
        "stores": "Sklepy",
        "operations": "Operacje",
        "health": "Kondycja",
        "hardware": "Sprzęt",
        "schedule": "Harmonogram",
        "cutOffTimes": "Godziny odcięcia",
        "map": "Mapa",
        "chainValues": "Wartości sieci",
        "storeValues": "Wartości sklepu",
        "iam": "IAM",
        "users": "Użytkownicy",
        "groups": "Grupy",
        "vendors": "Dostawcy",
        "permissions": "Uprawnienia",
        "sso": "SSO",
        "ingress": "Ingress",
        "imports": "Importy",
        "transformations": "Transformacje",
        "octo": "Octo",
        "rules": "Reguły",
        "visualizer": "Wizualizator",
        "action": "Action",
        "adaOrder": "AdaOrder",
        "adaPogs": "AdaPOGs",
        "backofficeLegacy": "Backoffice (starsze)",
        "developer": "Deweloper",
        "exec": "Exec",
        "fieldTool": "Narzędzie terenowe",
        "impact": "Impact",
        "messages": "Wiadomości",
        "productRecognition": "Rozpoznawanie produktów",
        "psi": "PSI",
        "review": "Przegląd",
        "setup": "Konfiguracja",
        "devices": "Urządzenia",
        "firmware": "Firmware",
        "blackhat": "Blackhat",
        "deployment": "Wdrożenie",
        "factoryQa": "QA fabryczne",
        "fieldDeployment": "Wdrożenie w terenie",
        "fieldIms": "IMS w terenie",
        "fieldMaintenanceVisit": "Wizyty serwisowe w terenie",
        "fieldQa": "QA w terenie",
        "fieldSetup": "Konfiguracja w terenie",
        "fieldStatus": "Status w terenie",
        "fieldStore": "Polecenia sklepu w terenie",
        "fieldTasks": "Zadania w terenie",
        "ims": "Przesyłki IMS",
        "imsAddresses": "Adresy IMS",
        "labelPrint": "Druk etykiet",
        "opsTasks": "Zadania operacyjne",
        "otaVersions": "Wersje OTA",
        "payment": "Płatności",
        "payroll": "Lista płac",
        "storeAccess": "Dostęp do sklepów"
      }
    }
  },
  "groups": {
    "title": "Grupy",
    "list": {
      "columns": {
        "id": "ID",
        "name": "Nazwa",
        "description": "Opis",
        "noOfUsers": "Użytkownicy",
        "createdAt": "Utworzono"
      },
      "addGroupButton": "Utwórz grupę",
      "searchPlaceholder": "Szukaj grup..."
    },
    "dialog": {
      "createTitle": "Utwórz grupę"
    },
    "form": {
      "name": "Nazwa",
      "description": "Opis",
      "validation": {
        "required": "Wymagane",
        "nameFormat": "Użyj małych liter, cyfr i podkreśleń (maks. 32 znaki)"
      }
    },
    "notifications": {
      "created": "Utworzono grupę „{{name}}”",
      "updated": "Zaktualizowano grupę „{{name}}”"
    }
  },
  "permissions": {
    "title": "Uprawnienia"
  },
  "visualizer": {
    "title": "Wizualizator"
  },
  "sso": {
    "title": "Jednokrotne logowanie",
    "pageTitle": "Jednokrotne logowanie — Domeny"
  },
  "vendors": {
    "title": "Dostawcy",
    "list": {
      "columns": {
        "id": "ID",
        "name": "Nazwa",
        "apiKey": "Klucz API",
        "chain": "Sieć",
        "status": "Status",
        "createdAt": "Utworzono"
      },
      "searchPlaceholder": "Szukaj dostawców...",
      "filter": {
        "chain": "Sieć",
        "searchChains": "Szukaj sieci…",
        "noChains": "Nie znaleziono sieci"
      },
      "actions": {
        "activate": "Aktywuj",
        "deactivate": "Dezaktywuj"
      },
      "addVendorButton": "Utwórz dostawcę"
    },
    "notifications": {
      "activated": "Dostawca \"{{name}}\" aktywowany",
      "deactivated": "Dostawca \"{{name}}\" dezaktywowany",
      "created": "Dostawca \"{{name}}\" utworzony"
    },
    "dialog": {
      "deactivateTitle": "Dezaktywuj dostawcę",
      "activateTitle": "Aktywuj dostawcę",
      "deactivatePrompt": "Czy na pewno chcesz dezaktywować",
      "activatePrompt": "Czy na pewno chcesz aktywować",
      "deactivateWarning": "Ten dostawca natychmiast utraci dostęp do API ingress i eksportu.",
      "deactivateConfirm": "Dezaktywuj",
      "activateConfirm": "Aktywuj",
      "createTitle": "Utwórz dostawcę",
      "createdTitle": "Dostawca utworzony",
      "createdWarning": "Skopiuj klucz prywatny teraz — nie zostanie wyświetlony ponownie.",
      "apiKeyLabel": "Klucz API",
      "privateKeyLabel": "Klucz prywatny"
    },
    "form": {
      "name": "Nazwa",
      "chain": "Sieć",
      "selectChain": "Wybierz sieć",
      "searchChains": "Szukaj sieci…",
      "noChains": "Nie znaleziono sieci",
      "validation": {
        "required": "Wymagane",
        "nameMaxLength": "Nazwa może mieć maksymalnie 32 znaki",
        "nameFormat": "Dozwolone są tylko małe litery, cyfry i podkreślenia"
      }
    },
    "usage": {
      "kind": {
        "ingress": "Ingress",
        "export": "Eksport"
      },
      "columns": {
        "id": "ID",
        "usage": "Użycie",
        "type": "Typ",
        "store": "Sklep",
        "chain": "Sieć",
        "source": "Źródło",
        "status": "Status",
        "createdAt": "Utworzono"
      },
      "storeDeleted": "{{id}} (usunięty)"
    }
  },
  "ingressImports": {
    "title": "Importy"
  },
  "transformations": {
    "title": "Transformacje",
    "list": {
      "columns": {
        "id": "ID",
        "name": "Nazwa",
        "key": "Klucz",
        "target": "Cel",
        "outputTypes": "Typy wyjściowe",
        "status": "Status",
        "createdAt": "Utworzono"
      },
      "addButton": "Utwórz transformację",
      "searchPlaceholder": "Szukaj transformacji...",
      "actions": {
        "activate": "Aktywuj",
        "deactivate": "Dezaktywuj",
        "viewSessions": "Zobacz sesje"
      },
      "filter": {
        "chain": "Sieć",
        "store": "Sklep"
      }
    },
    "dialog": {
      "createTitle": "Utwórz transformację",
      "comingSoon": "Wkrótce",
      "deactivateTitle": "Dezaktywuj transformację",
      "activateTitle": "Aktywuj transformację",
      "deactivatePrompt": "Czy na pewno chcesz dezaktywować",
      "activatePrompt": "Czy na pewno chcesz aktywować",
      "deactivateWarning": "Przed dezaktywacją transformacji sprawdź, czy nie jest używana w importerach SFTP/Email.",
      "deactivateConfirm": "Dezaktywuj",
      "activateConfirm": "Aktywuj"
    },
    "detail": {
      "title": "Szczegóły transformacji",
      "comingSoon": "Wkrótce",
      "tabs": {
        "info": "Informacje",
        "files": "Pliki",
        "sql": "SQL",
        "activityLog": "Aktywność"
      },
      "fields": {
        "id": "ID",
        "shortName": "Krótka nazwa",
        "description": "Opis",
        "target": "Cel",
        "outputTypes": "Typy wyjściowe",
        "perStore": "Na sklep",
        "onlyLiveStores": "Tylko aktywne sklepy",
        "status": "Status",
        "createdAt": "Utworzono",
        "inputFiles": "Pliki wejściowe",
        "yes": "Tak",
        "no": "Nie",
        "updatedAt": "Zaktualizowano",
        "sqlContent": "Zapytanie SQL",
        "sqlContentLabel": "Zawartość SQL",
        "copyToClipboard": "Kopiuj",
        "noFiles": "Brak zdefiniowanych plików wejściowych",
        "noSql": "Brak zawartości SQL",
        "fileType": "Typ pliku",
        "exampleFileName": "Przykładowy plik",
        "variesPerStore": "Różni się wg sklepu",
        "regex": "Regex",
        "forcedFix": "Wymuszona poprawka",
        "loadExtras": "Dodatkowe opcje",
        "validateColumns": "Walidacja kolumn",
        "checkDate": "Sprawdzanie daty",
        "targetName": "Nazwa docelowa"
      }
    }
  },
  "rules": {
    "title": "Reguły"
  },
  "chains": {
    "title": "Sieci",
    "tabs": {
      "info": "Info",
      "edit": "Edytuj",
      "settings": "Ustawienia",
      "regions": "Regiony",
      "stores": "Sklepy",
      "cutOffTimes": "Godziny odcięcia",
      "imports": "Importy",
      "activityLog": "Aktywność"
    },
    "list": {
      "columns": {
        "id": "ID",
        "legibleName": "Nazwa",
        "chainName": "Klucz",
        "timezone": "Strefa czasowa",
        "numberOfStores": "Sklepy",
        "status": "Status"
      },
      "actions": {
        "duplicate": "Duplikuj",
        "compareSettings": "Porównaj ustawienia"
      },
      "searchPlaceholder": "Szukaj sieci...",
      "filter": {},
      "addChainButton": "Utwórz sieć"
    },
    "form": {
      "legibleName": "Nazwa wyświetlana",
      "chainName": "Nazwa sieci",
      "defaultTimeZone": "Domyślna strefa czasowa",
      "copySettings": "Skopiuj ustawienia z istniejącej sieci",
      "selectTimezone": "Wybierz strefę czasową",
      "searchTimezones": "Szukaj stref czasowych…",
      "noTimezones": "Nie znaleziono stref czasowych",
      "selectCopyFrom": "Wybierz sieć źródłową",
      "searchCopyFrom": "Szukaj sieci…",
      "noCopyFrom": "Nie znaleziono sieci",
      "chainNameExists": "Sieć o tej nazwie już istnieje",
      "legibleNameExists": "Sieć o tej nazwie wyświetlanej już istnieje"
    },
    "dialog": {
      "createTitle": "Utwórz sieć",
      "duplicateTitle": "Duplikuj sieć"
    },
    "info": {
      "fields": {
        "displayName": "Nazwa wyświetlana",
        "chainName": "Nazwa sieci",
        "defaultTimeZone": "Domyślna strefa czasowa",
        "status": "Status",
        "stores": "Sklepy"
      },
      "storeSummary": "{{active}} aktywnych z {{total}}"
    },
    "notifications": {
      "created": "Sieć \"{{name}}\" utworzona",
      "updated": "Sieć \"{{name}}\" zaktualizowana"
    },
    "storeCount_one": "{{count}} sklep",
    "storeCount_few": "{{count}} sklepy",
    "storeCount_many": "{{count}} sklepów",
    "storeCount_other": "{{count}} sklepów",
    "regions": {
      "columns": {
        "regionName": "Nazwa regionu",
        "storesCount": "Sklepy"
      }
    },
    "compare": {
      "title": "Porównaj ustawienia",
      "onlyDiffs": "Różnice",
      "noDifferences": "Nie znaleziono różnic",
      "dialog": {
        "title": "Porównaj ustawienia sieci",
        "description": "Wybierz dwie sieci, aby porównać ich ustawienia.",
        "sourceLabel": "Sieć źródłowa",
        "targetLabel": "Porównaj z",
        "pickChain": "Wybierz sieć…",
        "compare": "Porównaj"
      }
    }
  },
  "stores": {
    "title": "Sklepy",
    "missingDataWarning": "Sklep nie ma kompletu danych, uzupełnij wartości i zapisz.",
    "list": {
      "columns": {
        "id": "ID",
        "legibleName": "Nazwa",
        "chain": "Sieć",
        "storeName": "Klucz",
        "storeCode": "Kod sklepu",
        "regionName": "Region",
        "timezone": "Strefa czasowa",
        "status": "Status"
      },
      "actions": {
        "duplicate": "Duplikuj",
        "deactivate": "Dezaktywuj",
        "activate": "Aktywuj",
        "archive": "Archiwizuj",
        "compareSettings": "Porównaj ustawienia",
        "tools": "Narzędzia",
        "triggerShc": "Pobierz SHC z API"
      },
      "searchPlaceholder": "Szukaj sklepów...",
      "filter": {
        "chain": "Sieć",
        "region": "Region",
        "searchRegions": "Szukaj regionów…",
        "noRegions": "Nie znaleziono regionów"
      },
      "addStoreButton": "Utwórz sklep"
    },
    "dialog": {
      "createTitle": "Utwórz sklep",
      "duplicateTitle": "Duplikuj sklep",
      "deactivateTitle": "Dezaktywuj sklep",
      "activateTitle": "Aktywuj sklep",
      "deactivatePrompt": "Czy na pewno chcesz dezaktywować",
      "deactivateConsequencesIntro": "Spowoduje to:",
      "deactivateConsequence1": "Wyłączenie wszystkich kamer należących do sklepu",
      "deactivateConsequence2": "Uniemożliwienie logowania użytkownikom przypisanym do sklepu",
      "activatePrompt": "Czy na pewno chcesz aktywować",
      "deactivateConfirm": "Dezaktywuj",
      "activateConfirm": "Aktywuj"
    },
    "form": {
      "legibleName": "Nazwa wyświetlana",
      "storeName": "Nazwa sklepu",
      "storeCode": "Kod sklepu",
      "chainName": "Sieć",
      "timeZone": "Strefa czasowa",
      "copySettings": "Skopiuj ustawienia z istniejącego sklepu",
      "selectChain": "Wybierz sieć",
      "searchChains": "Szukaj sieci…",
      "noChains": "Nie znaleziono sieci",
      "selectTimezone": "Wybierz strefę czasową",
      "searchTimezones": "Szukaj stref czasowych…",
      "noTimezones": "Nie znaleziono stref czasowych",
      "selectCopyFrom": "Wybierz sklep źródłowy",
      "searchCopyFrom": "Szukaj sklepów…",
      "noCopyFrom": "Nie znaleziono sklepów",
      "notSet": "Nie ustawiono",
      "goLiveDate": "Data uruchomienia",
      "cannotChangeAfterCreation": "Nie można zmienić po utworzeniu",
      "address": "Adres",
      "city": "Miasto",
      "state": "Województwo",
      "zipCode": "Kod pocztowy",
      "country": "Kraj",
      "region": "Region",
      "selectCountry": "Wybierz kraj",
      "searchCountries": "Szukaj krajów…",
      "noCountries": "Nie znaleziono krajów",
      "selectRegion": "Wybierz region",
      "searchRegions": "Szukaj regionów…",
      "noRegions": "Nie znaleziono regionów"
    },
    "cameraCount_one": "{{count}} urządzenie",
    "cameraCount_few": "{{count}} urządzenia",
    "cameraCount_many": "{{count}} urządzeń",
    "cameraCount_other": "{{count}} urządzeń",
    "compare": {
      "title": "Porównaj ustawienia",
      "onlyDiffs": "Różnice",
      "noDifferences": "Nie znaleziono różnic",
      "dialog": {
        "title": "Porównaj ustawienia sklepu",
        "description": "Wybierz dwa sklepy, aby porównać ich ustawienia.",
        "sourceLabel": "Sklep źródłowy",
        "targetLabel": "Porównaj z",
        "pickStore": "Wybierz sklep…",
        "compare": "Porównaj"
      }
    },
    "notifications": {
      "created": "Sklep \"{{name}}\" utworzony",
      "updated": "Sklep \"{{name}}\" zaktualizowany"
    },
    "info": {
      "wipBanner": "Prace w toku — wkrótce",
      "fields": {
        "displayName": "Nazwa wyświetlana",
        "storeName": "Nazwa sklepu",
        "storeCode": "Kod sklepu",
        "chain": "Sieć",
        "goLiveDate": "Data uruchomienia",
        "status": "Status",
        "address": "Adres",
        "city": "Miasto",
        "state": "Województwo",
        "zipCode": "Kod pocztowy",
        "country": "Kraj",
        "region": "Region",
        "timeZone": "Strefa czasowa",
        "openTime": "Godzina otwarcia",
        "closeTime": "Godzina zamknięcia",
        "deviceType": "Typ urządzenia",
        "cameras": "Urządzenia",
        "cameraOnTime": "Kamery włączone",
        "cameraOffTime": "Kamery wyłączone"
      },
      "cameraCountSummary": "{{active}} aktywnych z {{total}}",
      "storeDetails": {
        "title": "Szczegóły sklepu"
      },
      "address": {
        "title": "Adres"
      },
      "hours": {
        "title": "Godziny otwarcia"
      },
      "impactSettings": {
        "title": "Ustawienia Impact"
      },
      "matchSettings": {
        "title": "Ustawienia dopasowania"
      },
      "scheduleSettings": {
        "title": "Ustawienia harmonogramu"
      }
    },
    "operations": {
      "fields": {
        "storeHours": "Godziny otwarcia",
        "cameraHours": "Godziny pracy kamer",
        "priorityLogic": "Logika priorytetów",
        "sortingLogic": "Logika sortowania",
        "minWorkable": "Minimum do wykonania",
        "isPromoOnTop": "Promocje na górze",
        "isAssociatesCanSort": "Pracownicy mogą sortować",
        "isShowDsdItems": "Pokaż artykuły DSD",
        "isShowNonWorkable": "Pokaż niewykonalne",
        "isHidePog": "Ukryj POG",
        "isDisableIngress": "Wyłącz ingress",
        "isExcludeFromQueue": "Wyklucz z kolejki",
        "isDiscrepDisableIngress": "Wyłącz ingress rozbieżności",
        "cooldownHours": "Godziny przerwy"
      },
      "selectPriorityLogic": "Wybierz logikę priorytetów",
      "selectSortingLogic": "Wybierz logikę sortowania",
      "searchOption": "Szukaj…",
      "noOption": "Nie znaleziono opcji",
      "notifications": {
        "updated": "Ustawienia operacyjne zaktualizowane dla „{{name}}”"
      }
    },
    "hardware": {
      "fields": {
        "ssid": "SSID",
        "password": "Hasło",
        "username": "Nazwa użytkownika",
        "authMode": "Tryb autoryzacji",
        "timeout": "Limit czasu (ms)",
        "otaVersion": "Wersja OTA ESP32",
        "sc25OtaVersion": "Wersja OTA SC25",
        "sc25OtaComponentVersion": "Wersja OTA SC25 ({{cpuType}} / {{firmwareType}})",
        "forceUnfreezeDevices": "Wymuś przypisanie do wszystkich urządzeń",
        "overrideChainVersion": "Nadpisz wersję sieci",
        "remoteUrl": "URL odbiornika obrazu",
        "jpgQuality": "Jakość JPEG",
        "deploymentInterval": "Interwał wdrożenia",
        "streamingTime": "Czas strumieniowania (s)",
        "autoWhiteBalance": "Automatyczny balans bieli"
      },
      "firmwareSection": "Firmware",
      "networkSection": "Sieć",
      "selectAuthMode": "Wybierz tryb autoryzacji",
      "selectOtaVersion": "Wybierz wersję OTA ESP32",
      "selectSc25OtaVersion": "Wybierz wersję OTA SC25",
      "forceUnfreezeDevicesHint": "Konfiguracje OTA pojedynczych urządzeń zostaną nadpisane",
      "notifications": {
        "updated": "Ustawienia sprzętowe zaktualizowane dla „{{name}}”"
      }
    },
    "map": {
      "title": "Mapa sklepu",
      "noMap": "Brak przesłanej mapy dla tego sklepu.",
      "uploadButton": "Prześlij mapę",
      "uploadSuccess": "Mapa przesłana pomyślnie",
      "zoomIn": "Powiększ",
      "zoomOut": "Pomniejsz",
      "resetView": "Zresetuj widok"
    },
    "schedule": {
      "everyday": "Harmonogram codzienny",
      "exceptions": "Wyjątki",
      "noExceptions": "Brak wyjątków. Codzienny harmonogram obowiązuje każdego dnia.",
      "legend": "Legenda:",
      "copyEveryday": "Kopiuj codzienny",
      "addPinHint": "Kliknij oś, aby dodać czas przechwytywania",
      "algorithmTimed": "{{count}} obrazów/dzień · czas wg algorytmu",
      "capturesPerDay": "{{count}} obrazów/dzień",
      "fields": {
        "images": "Obrazy",
        "awakeTime": "Wybudzenie"
      },
      "strategies": {
        "every_hour": "Co godzinę",
        "no_of_images": "N obrazów/dzień",
        "static": "Okna czasowe",
        "strict": "Dokładne godziny"
      },
      "labels": {
        "model": "Model",
        "off": "Wył.",
        "human": "Człowiek",
        "qr": "QR"
      },
      "popover": {
        "window": "Okno {{range}}",
        "slotAt": "Przechwycenie o {{time}}",
        "remove": "Usuń"
      },
      "exception": {
        "addTitle": "Dodaj wyjątek",
        "editTitle": "Edytuj wyjątek",
        "subtitle": "Wybierz, kiedy ten harmonogram zastępuje codzienny.",
        "scheduleHeading": "Harmonogram wyjątku",
        "name": "Nazwa",
        "tickets": "Zgłoszenia",
        "rule": "Reguła",
        "ruleInvalid": "Nieprawidłowa składnia reguły",
        "variables": "Dostępne zmienne"
      },
      "notifications": {
        "updated": "Zaktualizowano harmonogram dla „{{name}}”"
      },
      "mixedLabel": "Mieszane",
      "add": "Dodaj"
    },
    "cutOffTimes": {
      "searchPlaceholder": "Szukaj godzin odcięcia...",
      "noCutOffTimes": "Brak godzin odcięcia",
      "everyDay": "Codziennie",
      "default": "Domyślna",
      "localTimeNote": "Godziny w czasie lokalnym sklepu",
      "useCases": {
        "reporting": "Raportowanie",
        "impact": "Impact"
      },
      "scopes": {
        "store": "sklep",
        "chain": "sieć"
      },
      "filter": {
        "useCase": "Zastosowanie",
        "scope": "Poziom"
      },
      "columns": {
        "id": "ID",
        "cutOffTime": "Godzina",
        "useCase": "Zastosowanie",
        "dayOfWeek": "Dni",
        "department": "Dział",
        "taskType": "Typ zadania",
        "isDefault": "Domyślna",
        "scope": "Ustawione na"
      },
      "days": {
        "mon": "Pon",
        "tue": "Wt",
        "wed": "Śr",
        "thu": "Czw",
        "fri": "Pt",
        "sat": "Sob",
        "sun": "Nd"
      },
      "addButton": "Dodaj godzinę odcięcia",
      "form": {
        "createTitle": "Dodaj godzinę odcięcia",
        "editTitle": "Edytuj godzinę odcięcia",
        "chainWideWarning": "Dotyczy wszystkich sklepów w sieci, chyba że sklep nadpisze ją własną godziną odcięcia.",
        "cutOffTime": "Godzina",
        "useCase": "Zastosowanie",
        "days": "Dni",
        "department": "Dział",
        "taskType": "Typ zadania",
        "isDefault": "Domyślna",
        "isDefaultHint": "Użyj jako główną godzinę odcięcia dla tego warunku",
        "everyDayHint": "brak wyboru — codziennie",
        "notRequired": "opcjonalne",
        "validation": {
          "cutOffTimeRequired": "Wybierz godzinę odcięcia",
          "cutOffTimeStep": "Godziny odcięcia co 15 minut"
        },
        "duplicate": "Godzina odcięcia o tych ustawieniach już istnieje dla tego sklepu"
      },
      "notifications": {
        "created": "Dodano godzinę odcięcia",
        "createFailed": "Nie udało się dodać godziny odcięcia",
        "updated": "Zaktualizowano godzinę odcięcia",
        "updateFailed": "Nie udało się zaktualizować godziny odcięcia",
        "deleted": "Usunięto godzinę odcięcia",
        "deleteFailed": "Nie udało się usunąć godziny odcięcia"
      },
      "actions": {
        "edit": "Edytuj",
        "delete": "Usuń",
        "noChainPermissionHint": "Nie masz uprawnień do zmiany godzin odcięcia dla całej sieci",
        "noStorePermissionHint": "Nie masz uprawnień do zmiany godzin odcięcia tego sklepu"
      },
      "deleteDialog": {
        "title": "Usunąć godzinę odcięcia?",
        "description": "Godzina odcięcia {{useCase}} o {{time}} zostanie usunięta. Tej operacji nie można cofnąć.",
        "chainWideWarning": "To godzina odcięcia dla całej sieci. Usunięcie zmieni działanie każdego sklepu w sieci, który nie ustawia własnej.",
        "confirm": "Usuń"
      }
    },
    "bulkCreate": {
      "title": "Masowe tworzenie sklepów",
      "sheet": "Arkusz",
      "uploadPrompt": "Prześlij arkusz kalkulacyjny",
      "uploadHint": "XLSX, XLS lub CSV — pierwszy wiersz musi zawierać nagłówki kolumn",
      "selectColumn": "Wybierz kolumnę",
      "noColumn": "— Brak —",
      "unnamedColumn": "Kolumna {{index}}",
      "rowCount": "Wiersze: {{count}}",
      "previewNote": "Wyświetlono {{shown}} z {{total}} wierszy",
      "validSummary": "{{valid}} poprawnych · {{invalid}} z błędami",
      "rowColumn": "Wiersz",
      "errorColumn": "Błąd",
      "creating": "Tworzenie sklepów…",
      "createdCount": "Utworzono: {{count}}",
      "failedCount": "Niepowodzenia: {{count}}",
      "createButton": "Utwórz {{count}} sklepów",
      "downloadFailures": "Pobierz błędy",
      "back": "Wstecz",
      "errors": {
        "noSheets": "Nie znaleziono arkuszy w pliku",
        "parseFailed": "Nie udało się odczytać pliku",
        "createFailed": "Tworzenie nie powiodło się",
        "missing": "{{field}} jest wymagane",
        "unknownChain": "Nie znaleziono sieci ‘{{chain}}’",
        "dupCode": "Zduplikowany kod sklepu ‘{{code}}’",
        "requiredUnmapped": "Przypisz wszystkie wymagane pola (*), aby kontynuować",
        "badTime": "{{field}} „{{raw}}\" nie jest prawidłową godziną",
        "timeOrder": "Godzina otwarcia nie może być późniejsza niż zamknięcia",
        "hoursFailed": "Nie udało się odczytać sklepu, aby ustawić godziny",
        "hoursUnavailable": "Pominięto godziny otwarcia — dane operacyjne sklepu były niedostępne",
        "patchFailed": "Aktualizacja uzupełniająca nie powiodła się",
        "cameraTimeOrder": "Godzina włączenia kamer nie może być późniejsza niż wyłączenia"
      },
      "mode": {
        "column": "Kolumna",
        "constant": "Wartość",
        "computed": "Obliczone"
      },
      "computedHint": "Wyliczone: chain_storeCode",
      "valuePlaceholder": "Wprowadź wartość",
      "next": "Dalej",
      "selectedSummary": "Wybrano {{selected}} z {{total}}",
      "existsSummary": "{{count}} już istnieje",
      "invalidSummary": "{{count}} nieprawidłowych",
      "selectAll": "Zaznacz wszystkie",
      "searchColumns": "Szukaj kolumn…",
      "noColumns": "Nie znaleziono kolumn",
      "appendCode": "+ (kod sklepu)",
      "selectSheet": "Wybierz arkusz",
      "searchSheets": "Szukaj arkuszy…",
      "noSheetsFound": "Nie znaleziono arkuszy",
      "includeAddress": "Dołącz adres",
      "active": "Aktywny",
      "includeHours": "Dołącz godziny sklepu i kamer",
      "patchFailedCount": "Nieudane aktualizacje uzupełniające: {{count}}",
      "patchIssue": "Sklep utworzony, aktualizacja uzupełniająca nieudana: {{error}}",
      "skippedCount": "Pominięto: {{count}}",
      "skippedExists": "Pominięto — sklep już istnieje"
    },
    "tools": {
      "menuLabel": "Narzędzia",
      "bulkCreate": "Masowe tworzenie sklepów"
    }
  },
  "storeHealth": {
    "refreshAll": "Odśwież wszystko",
    "refreshPanel": "Odśwież: {{panel}}",
    "lastChecked": "Ostatnio sprawdzono {{time}}",
    "retry": "Ponów",
    "panelError": "Nie udało się załadować tego panelu.",
    "noReferenceStore": "Ta sieć nie ma skonfigurowanego sklepu referencyjnego, więc nie ma z czym porównywać.",
    "searchPlaceholder": "Szukaj tabeli i ustawienia…",
    "clearSearch": "Wyczyść wyszukiwanie",
    "onlyDifferences": "Tylko różnice ({{count}})",
    "noRows": "Brak danych do wyświetlenia.",
    "status": {
      "pass": "Zaliczone",
      "warn": "Ostrzeżenie",
      "fail": "Błąd",
      "info": "Info",
      "skip": "Pominięte"
    },
    "origin": {
      "canon": "Kanon",
      "reference": "Referencja",
      "store-only": "Tylko sklep"
    },
    "columns": {
      "check": "Kontrola",
      "status": "Status",
      "value": "Wartość",
      "threshold": "Próg",
      "setting": "Ustawienie",
      "expected": "Oczekiwano",
      "storeValue": "Wartość sklepu"
    },
    "panels": {
      "identity": {
        "title": "Tożsamość i konfiguracja",
        "description": "Fizyczna konfiguracja i dane identyfikacyjne sklepu."
      },
      "cameras": {
        "title": "Kamery i szablony",
        "description": "Streaming kamer, dryf szablonów i zaległe zadania skanowania."
      },
      "planograms": {
        "title": "Planogramy i katalog",
        "description": "Pokrycie planogramów i jakość katalogu."
      },
      "imports": {
        "title": "Importy",
        "description": "Przychodzące dane klienta i aktualność pojemności półek."
      },
      "settingsDiff": {
        "title": "Różnice ustawień i konfiguracji",
        "description": "Porównanie z <store/>. Diagnostyka — to nie werdykt zaliczone/błąd.",
        "descriptionGeneric": "Porównanie ze sklepem referencyjnym sieci. Diagnostyka — to nie werdykt zaliczone/błąd."
      }
    }
  },
  "dataTable": {
    "noResults": "Brak wyników.",
    "showing": "Wyświetlanie {{from}}-{{to}} z {{total}}",
    "noResultsCount": "Brak wyników",
    "rows": "{{count}} wierszy",
    "export": "Eksportuj",
    "resetColumns": "Przywróć domyślne",
    "allTimesIn": "Wszystkie czasy w <tz/>"
  },
  "common": {
    "loading": "Ładowanie…",
    "useValue": "Użyj „{{value}}”",
    "noResults": "Nie znaleziono wyników",
    "copiedToClipboard": "Skopiowano do schowka:",
    "active": "Aktywne",
    "workInProgress": "Prace w toku…",
    "createdAt": "Utworzono",
    "updatedAt": "Zaktualizowano",
    "clear": "Wyczyść",
    "fileTypeNotAccepted": "Akceptowane są tylko pliki {{types}}"
  },
  "passkeys": {
    "title": "Klucze dostępu",
    "description": "Klucze dostępu pozwalają logować się odciskiem palca, twarzą lub PIN-em urządzenia zamiast hasła.",
    "empty": "Brak kluczy dostępu. Dodaj jeden, aby następnym razem logować się szybciej.",
    "namePlaceholder": "Nazwa klucza (np. MacBook Touch ID)",
    "add": "Dodaj klucz",
    "adding": "Konfigurowanie…",
    "registered": "Dodano klucz dostępu",
    "revoke": "Unieważnij",
    "revoked": "Klucz dostępu unieważniony",
    "added": "Dodano {{date}}",
    "lastUsed": "ostatnio użyty {{date}}",
    "neverUsed": "nigdy nie użyty",
    "deviceType": {
      "multi_device": "Zsynchronizowany",
      "single_device": "To urządzenie"
    },
    "error": "Coś poszło nie tak. Spróbuj ponownie.",
    "revokeDialog": {
      "title": "Unieważnij klucz dostępu",
      "prompt": "Czy na pewno chcesz unieważnić",
      "warning": "Tego klucza dostępu nie będzie można już użyć do logowania. Ta operacja jest nieodwracalna.",
      "confirm": "Unieważnij"
    }
  },
  "settings": {
    "title": "Ustawienia",
    "columns": {
      "name": "Nazwa",
      "key": "Klucz",
      "setting": "Ustawienie"
    },
    "info": {
      "title": "Informacje o ustawieniu",
      "showMore": "Pokaż więcej",
      "showLess": "Pokaż mniej",
      "fields": {
        "key": "Klucz",
        "name": "Nazwa",
        "description": "Opis",
        "noDescription": "Brak opisu",
        "group": "Grupa",
        "type": "Typ",
        "defaultValue": "Wartość domyślna",
        "chainOverrides": "Nadpisania sieci",
        "storeOverrides": "Nadpisania sklepu"
      }
    },
    "list": {
      "columns": {
        "id": "ID",
        "name": "Nazwa",
        "key": "Klucz",
        "groupName": "Grupa",
        "fieldType": "Typ",
        "defaultValue": "Domyślna",
        "chainOverrides": "Nadpisania sieci",
        "storeOverrides": "Nadpisania sklepu",
        "value": "Wartość",
        "source": "Źródło",
        "status": "Status"
      },
      "filter": {
        "overridesOnly": "Nadpisania",
        "group": "Grupa",
        "searchGroups": "Szukaj grup…",
        "noGroups": "Nie znaleziono grup",
        "chainOverrides": "Nadpisania sieci",
        "storeOverrides": "Nadpisania sklepów"
      },
      "searchPlaceholder": "Szukaj ustawień...",
      "actions": {
        "edit": "Edytuj",
        "restoreDefault": "Przywróć domyślną wartość"
      },
      "editDialog": {
        "title": "Edytuj ustawienie",
        "nameLabel": "Nazwa",
        "keyLabel": "Klucz",
        "defaultValueLabel": "Wartość domyślna",
        "valueLabel": "Wartość",
        "selectPlaceholder": "Wybierz wartość",
        "selectSearchPlaceholder": "Szukaj wartości…",
        "noValues": "Brak wartości",
        "invalidNumber": "Musi być prawidłową liczbą",
        "cancel": "Anuluj",
        "save": "Zapisz"
      },
      "restoreDialog": {
        "title": "Przywróć domyślną wartość",
        "description": "Czy na pewno chcesz przywrócić \"{{name}}\" do wartości domyślnej?",
        "cancel": "Anuluj",
        "confirm": "Przywróć"
      },
      "toast": {
        "updated": "Ustawienie \"{{name}}\" zaktualizowane",
        "updateError": "Nie udało się zaktualizować ustawienia",
        "restored": "Ustawienie \"{{name}}\" przywrócono do wartości domyślnej",
        "restoreError": "Nie udało się przywrócić ustawienia"
      },
      "jsonPreview": {
        "description": "Ten podgląd jest sformatowany dla czytelności. Oryginalna wartość jest przechowywana w formie zminifikowanej.",
        "copy": "Kopiuj"
      }
    },
    "chains": {
      "columns": {
        "id": "ID",
        "name": "Sieć",
        "value": "Wartość",
        "status": "Status"
      },
      "searchPlaceholder": "Szukaj sieci…"
    },
    "stores": {
      "columns": {
        "id": "ID",
        "store": "Sklep",
        "chain": "Sieć",
        "value": "Wartość",
        "status": "Status"
      },
      "searchPlaceholder": "Szukaj sklepów…"
    },
    "status": {
      "override": "nadpisanie",
      "default": "domyślny",
      "store": "sklep",
      "chain": "sieć"
    }
  },
  "imports": {
    "importData": "Importuj dane",
    "importCsv": "Importuj CSV",
    "searchPlaceholder": "Szukaj importów…",
    "columns": {
      "id": "ID",
      "publicId": "Publiczne ID",
      "timestamp": "Utworzono",
      "type": "Typ",
      "createdBy": "Przesłane przez",
      "store": "Sklep",
      "source": "Źródło",
      "processingTime": "Czas przetwarzania",
      "status": "Status",
      "validationTime": "Czas walidacji",
      "queueingTime": "Czas oczekiwania",
      "itemsFound": "Znalezione elementy",
      "productsFound": "Znalezione produkty",
      "productsCreated": "Utworzone produkty",
      "productsUpdated": "Zaktualizowane produkty",
      "productsZeroed": "Wyzerowane produkty",
      "storeCode": "Kod sklepu",
      "items": "Elementy",
      "createdAt": "Utworzono"
    },
    "actions": {
      "retrigger": "Uruchom ponownie",
      "downloadJson": "Pobierz plik JSON",
      "downloadCsv": "Pobierz plik CSV",
      "copyRawJson": "Kopiuj surową ścieżkę JSON",
      "copyRawCsv": "Kopiuj surową ścieżkę CSV",
      "downloadError": "Nie udało się wygenerować linku do pobrania"
    },
    "retrigger": {
      "title": "Uruchom import ponownie",
      "prompt": "Uruchom ten import jeszcze raz. Przydatne po błędzie.",
      "confirm": "Uruchom ponownie",
      "success": "Import #{{id}} dodany do kolejki ponownego uruchomienia",
      "errorTitle": "Nie udało się uruchomić importu ponownie",
      "errors": {
        "missingContent": "Import #{{id}} nie ma przygotowanego pliku JSON i nie można go uruchomić ponownie.",
        "notFound": "Nie znaleziono importu #{{id}}."
      },
      "includeSubsequent": {
        "label": "Uruchom również kolejne importy",
        "hint": "Ponowi po kolei późniejsze importy tego samego typu dla tego sklepu."
      }
    },
    "csv": {
      "title": "Importuj CSV",
      "typeLabel": "Typ importu",
      "typePlaceholder": "Wybierz typ importu…",
      "types": {
        "metadata": "Metadane",
        "boh": "Stan magazynowy",
        "sales": "Sprzedaż",
        "pricing": "Ceny"
      },
      "fileLabel": "Plik CSV",
      "fileDropTitle": "Upuść plik CSV lub kliknij, aby wgrać",
      "overrideStoreCode": "Nadpisz kod sklepu",
      "uploadingPercent": "Wgrywanie… {{percent}}%",
      "processing": "Konwertowanie wierszy…",
      "upload": "Wgraj",
      "success": "Utworzono import #{{id}} z {{count}} elementami",
      "errorTitle": "Nie udało się zaimportować tego pliku",
      "moreErrors": "…i {{count}} więcej"
    },
    "wizard": {
      "title": "Importuj dane",
      "submitButton": "Wyślij import",
      "submittedSuccess": "Import został wysłany",
      "inactiveTransformation": {
        "title": "Ta transformacja jest dezaktywowana",
        "hint": "Możesz mimo to wysłać import, ale spójność i niezawodność importowanych danych nie są gwarantowane."
      },
      "steps": {
        "scope": "Zakres",
        "transformation": "Transformacja",
        "upload": "Wgrywanie",
        "validate": "Walidacja",
        "preview": "Podgląd"
      },
      "scope": {
        "selectChain": "Wybierz sieć…",
        "searchChains": "Szukaj sieci…",
        "noChains": "Nie znaleziono sieci",
        "selectStore": "Wybierz sklep (opcjonalnie)…",
        "searchStores": "Szukaj sklepów…",
        "noStores": "Nie znaleziono sklepów"
      },
      "transformation": {
        "select": "Wybierz transformację…",
        "search": "Szukaj transformacji…",
        "empty": "Nie znaleziono transformacji",
        "filesToPrepare": "Pliki do przygotowania"
      },
      "upload": {
        "startingSession": "Rozpoczynanie sesji importu…",
        "uploadingPercent": "Wgrywanie… {{percent}}%",
        "processing": "Przetwarzanie…",
        "dropFile": "Upuść plik lub kliknij, aby wgrać ({{fileType}})"
      },
      "validate": {
        "validating": "Walidowanie plików…",
        "errorsTitle": "Znaleziono błędy walidacji",
        "errorsCount": "{{errors}} błędów w {{files}} plikach",
        "errorColumn": "(kolumna: {{column}})",
        "errorRow": "w wierszu {{location}}"
      },
      "preview": {
        "submitting": "Wysyłanie importu…",
        "preparing": "Przygotowywanie żądań importu…",
        "preparingProgress": "Przygotowywanie sklepu {{current}} z {{total}}…",
        "submittingProgress": "Tworzenie żądania importu {{current}} z {{total}}…",
        "filesProcessed": "Przetworzone pliki",
        "validFiles": "Poprawne pliki",
        "totalRecords": "Łącznie rekordów",
        "storesAffected": "Sklepy objęte importem",
        "estDuration": "Szac. czas",
        "storeCodes": "Przetworzone kody sklepów",
        "importRequests": "Żądania importu",
        "itemsCount": "{{count}} elementów"
      }
    }
  },
  "tabs": {
    "info": "Info",
    "health": "Kondycja",
    "edit": "Edytuj",
    "permissions": "Uprawnienia",
    "boPermissions": "Uprawnienia BO",
    "users": "Użytkownicy",
    "chains": "Sieci",
    "stores": "Sklepy",
    "map": "Mapa",
    "settings": "Ustawienia",
    "operations": "Operacje",
    "schedule": "Harmonogram",
    "cutOffTimes": "Godziny odcięcia",
    "devices": "Urządzenia",
    "hardware": "Sprzęt",
    "imports": "Importy",
    "security": "Bezpieczeństwo",
    "activityLog": "Aktywność",
    "usage": "Użycie"
  },
  "profile": {
    "title": "Mój profil",
    "edit": {
      "wip": "Edycja profilu nie jest jeszcze dostępna."
    },
    "security": {
      "sso": {
        "title": "Konto z logowaniem jednokrotnym",
        "description": "Logujesz się przez dostawcę tożsamości Twojej organizacji (SSO). Hasło, passkeys i uwierzytelnianie dwuskładnikowe są tam zarządzane i nie można ich skonfigurować tutaj."
      },
      "password": {
        "title": "Hasło",
        "description": "Zmień hasło używane do logowania.",
        "current": "Obecne hasło",
        "new": "Nowe hasło",
        "confirm": "Potwierdź nowe hasło",
        "submit": "Zmień hasło",
        "submitting": "Zmienianie…",
        "success": "Hasło zmienione",
        "required": "To pole jest wymagane",
        "tooShort": "Użyj co najmniej 8 znaków",
        "mismatch": "Nowe hasła nie są takie same",
        "invalid": "Obecne hasło jest nieprawidłowe",
        "error": "Nie udało się zmienić hasła. Spróbuj ponownie."
      },
      "mfa": {
        "title": "Uwierzytelnianie dwuskładnikowe",
        "description": "Dodaj dodatkową warstwę zabezpieczeń za pomocą aplikacji uwierzytelniającej.",
        "statusLabel": "Aplikacja uwierzytelniająca",
        "enabledStatus": "Włączone",
        "setup": "Skonfiguruj dwuskładnikowe",
        "disable": "Wyłącz",
        "setupTitle": "Skonfiguruj uwierzytelnianie dwuskładnikowe",
        "setupDescription": "Zeskanuj kod QR aplikacją uwierzytelniającą, a następnie wpisz 6-cyfrowy kod, aby potwierdzić.",
        "qrAlt": "Kod QR uwierzytelniania dwuskładnikowego",
        "secretLabel": "Lub wpisz ten klucz konfiguracyjny ręcznie",
        "codeLabel": "Kod weryfikacyjny",
        "enable": "Włącz",
        "enabled": "Uwierzytelnianie dwuskładnikowe włączone",
        "invalidCode": "Kod się nie zgadza. Spróbuj ponownie.",
        "generateError": "Nie udało się rozpocząć konfiguracji. Spróbuj ponownie.",
        "disableTitle": "Wyłącz uwierzytelnianie dwuskładnikowe",
        "disableConfirm": "Twoje konto nie będzie już wymagać kodu weryfikacyjnego przy logowaniu. Na pewno?",
        "disabled": "Uwierzytelnianie dwuskładnikowe wyłączone",
        "disableError": "Nie udało się wyłączyć uwierzytelniania dwuskładnikowego. Spróbuj ponownie."
      }
    },
    "settings": {
      "appearance": {
        "title": "Wygląd",
        "description": "Motyw, język i format daty dla tego urządzenia."
      },
      "theme": {
        "label": "Motyw"
      },
      "accent": {
        "label": "Kolor akcentu",
        "options": {
          "green": "Zielony",
          "red": "Czerwony",
          "blue": "Niebieski"
        }
      },
      "language": {
        "label": "Język",
        "hint": "Dotyczy tylko etykiet i komunikatów — nie zmienia formatu daty."
      },
      "dateFormat": {
        "label": "Format daty",
        "hint": "Dotyczy wszystkich dat w aplikacji. „System” używa ustawień regionalnych Twojego systemu operacyjnego.",
        "options": {
          "system": "System",
          "dmy": "Najpierw dzień",
          "mdy": "Najpierw miesiąc",
          "iso": "Najpierw rok (ISO)"
        }
      },
      "tables": {
        "title": "Tabele",
        "description": "Domyślne ustawienia widoków list i tabel."
      },
      "itemsPerPage": {
        "label": "Elementów na stronie",
        "hint": "Stosowane przy następnym otwarciu każdej tabeli."
      },
      "integrations": {
        "title": "Integracje",
        "description": "Połącz swoje konta z Focal."
      },
      "slack": {
        "label": "Nazwa użytkownika Slack",
        "placeholder": "@twoj.login",
        "hint": "Zapisywane na Twoim koncie.",
        "save": "Zapisz",
        "saved": "Zapisano nazwę użytkownika Slack",
        "saveError": "Nie udało się zapisać nazwy użytkownika Slack. Spróbuj ponownie."
      },
      "advanced": {
        "title": "Zaawansowane",
        "description": "Opcje diagnostyki i resetowania."
      },
      "diagnostics": {
        "title": "Diagnostyka",
        "description": "Narzędzia dla programistów i QA dla tego urządzenia."
      },
      "httpErrorToasts": {
        "label": "Pokazuj powiadomienia o błędach HTTP",
        "hint": "Pokazuje powiadomienie ze szczegółami żądania i odpowiedzi przy każdym nieudanym wywołaniu API (422, 5xx lub błąd sieci). Przydatne do QA i debugowania."
      },
      "reset": {
        "title": "Resetuj preferencje",
        "description": "Przywróć wszystkie lokalne ustawienia urządzenia do wartości domyślnych.",
        "button": "Resetuj lokalne preferencje",
        "toast": "Preferencje zresetowane",
        "dialog": {
          "title": "Zresetować lokalne preferencje?",
          "description": "Spowoduje to wyczyszczenie motywu, języka, układów tabel i innych lokalnych ustawień, a następnie ponowne wczytanie aplikacji. Nie wpłynie to na Twoje konto ani logowanie.",
          "cancel": "Anuluj",
          "confirm": "Resetuj"
        }
      }
    }
  },
  "activity": {
    "searchPlaceholder": "Szukaj aktywności...",
    "empty": "Brak aktywności",
    "wipBanner": "Prace w toku — dane są symulowane",
    "filter": {
      "timeRange": "Zakres czasu",
      "onlyChain": "Tylko sieć"
    }
  },
  "buttons": {
    "cancel": "Anuluj",
    "create": "Utwórz",
    "save": "Zapisz",
    "discard": "Odrzuć",
    "stayOnPage": "Zostań na stronie",
    "discardAndLeave": "Odrzuć i wyjdź",
    "schedule": "Zaplanuj",
    "submitForApproval": "Prześlij do zatwierdzenia",
    "back": "Wstecz",
    "next": "Dalej",
    "validate": "Waliduj",
    "edit": "Edytuj",
    "done": "Gotowe",
    "close": "Zamknij"
  },
  "unsavedChanges": {
    "title": "Niezapisane zmiany",
    "description": "Masz niezapisane zmiany. Czy na pewno chcesz opuścić stronę? Zmiany zostaną utracone."
  },
  "notifications": {
    "title": "Powiadomienia",
    "empty": "Brak powiadomień",
    "wipBanner": "Prace w toku — dane są symulowane",
    "markAllRead": "Oznacz wszystkie jako przeczytane",
    "markRead": "Oznacz jako przeczytane",
    "dismiss": "Odrzuć",
    "actions": {
      "review": "Sprawdź",
      "approve": "Zatwierdź"
    },
    "mock": {
      "importFailed": {
        "title": "Import nieudany dla Lidl DE #4012",
        "description": "Import katalogu produktów nie powiódł się z powodu brakujących wymaganych kolumn. Wymagana ręczna weryfikacja."
      },
      "settingApproval": {
        "title": "Zmiana ustawienia wymaga zatwierdzenia",
        "description": "\"camera_resolution\" zostało zmienione w Aldi Süd — Berlin Mitte. Oczekuje na zatwierdzenie."
      },
      "importComplete": {
        "title": "Import zakończony pomyślnie",
        "description": "Import planogramu dla Carrefour FR zakończony — przetworzono 847 pozycji."
      },
      "storeOffline": {
        "title": "Kamery sklepu offline",
        "description": "3 kamery w Tesco UK — Manchester Central są offline od ponad 2 godzin."
      },
      "userCreated": {
        "title": "Utworzono nowego użytkownika",
        "description": "Użytkownik \"m.schmidt@lidl.com\" został utworzony i przypisany do Lidl DE."
      },
      "settingUpdated": {
        "title": "Ustawienie zaktualizowane",
        "description": "Domyślna wartość \"detection_threshold\" zmieniona z 0,7 na 0,75."
      }
    }
  },
  "header": {
    "commands": "Polecenia..."
  },
  "approvals": {
    "title": "Zatwierdzenia",
    "tabs": {
      "pending": "Oczekujące",
      "resolved": "Rozpatrzone"
    },
    "status": {
      "pending": "Oczekujące",
      "approved": "Zatwierdzone",
      "rejected": "Odrzucone",
      "executed": "Wykonane",
      "failed": "Nieudane"
    },
    "actions": {
      "approve": "Zatwierdź",
      "reject": "Odrzuć"
    },
    "actionTypes": {
      "create-chain": "Utwórz chain"
    },
    "scheduleForLater": "Zaplanuj na później",
    "requestedExecutionTime": "Żądany czas wykonania (po zatwierdzeniu)",
    "scheduledFor": "Zaplanowano na {{time}}",
    "scheduledForFooter": "Zaplanowano na: {{time}}",
    "requestedBy": "Zgłoszone przez {{name}}",
    "resolvedBy": "{{action}} przez {{name}}",
    "rejectionReason": "Powód (opcjonalny)",
    "rejectDescription": "Podaj opcjonalny powód odrzucenia tej akcji.",
    "submitDialog": {
      "title": "Prześlij do zatwierdzenia",
      "titleWithAction": "Prześlij \"{{action}}\" do zatwierdzenia",
      "description": "Sprawdź poniższe szczegóły. Administrator musi zatwierdzić tę akcję przed jej wykonaniem.",
      "scheduleHint": "Pozostaw puste, aby wykonać natychmiast po zatwierdzeniu.",
      "messagePlaceholder": "Wiadomość do zatwierdzającego (opcjonalna)"
    },
    "clearSchedule": "Wyczyść",
    "noActions": "Brak oczekujących akcji",
    "wipBanner": "Prace w toku — dane są symulowane",
    "noResolvedActions": "Brak rozpatrzonych akcji",
    "notifications": {
      "scheduled": "\"{{name}}\" zostało zaplanowane",
      "submittedForApproval": "\"{{name}}\" przesłano do zatwierdzenia"
    }
  },
  "commandPalette": {
    "placeholder": "Wpisz polecenie lub szukaj...",
    "empty": "Nie znaleziono wyników.",
    "pages": "Strony",
    "settings": "Ustawienia",
    "commands": "Polecenia",
    "profile": "Profil",
    "myProfile": "Mój profil",
    "debug": "Debugowanie",
    "logout": "Wyloguj",
    "back": "Wróć",
    "footer": {
      "navigate": "Nawiguj",
      "select": "Wybierz",
      "goBack": "Wróć",
      "close": "Zamknij"
    },
    "createChain": "Utwórz sieć",
    "createStore": "Utwórz sklep",
    "createUser": "Utwórz użytkownika",
    "createVendor": "Utwórz dostawcę",
    "createTransformation": "Utwórz transformację",
    "importData": "Importuj dane",
    "compareChainSettings": "Porównaj ustawienia sieci",
    "compareStoreSettings": "Porównaj ustawienia sklepu",
    "refreshView": "Odśwież bieżący widok",
    "featureFlags": "Flagi funkcji",
    "telemetry": "Telemetria API",
    "showcase": "Przegląd komponentów",
    "flagOn": "włączone",
    "flagOff": "wyłączone",
    "telemetryClearAll": "Wyczyść wszystko",
    "telemetryEmpty": "Brak zarejestrowanych żądań.",
    "theme": {
      "title": "Zmień motyw",
      "placeholder": "Wybierz motyw...",
      "light": "Jasny",
      "dark": "Ciemny",
      "system": "Systemowy"
    },
    "accent": {
      "title": "Zmień kolor akcentu",
      "placeholder": "Wybierz kolor akcentu..."
    },
    "language": {
      "title": "Zmień język",
      "placeholder": "Wybierz język..."
    },
    "createOctoRule": "Utwórz regułę Octo",
    "createFirmwareVersion": "Utwórz wersję firmware"
  },
  "octoRules": {
    "title": "Reguły Octo",
    "unnamed": "Reguła #{{id}}",
    "unnamedShort": "Bez nazwy",
    "scopeGlobal": "Globalne",
    "list": {
      "columns": {
        "id": "ID",
        "name": "Nazwa",
        "scope": "Zakres",
        "stage": "Etap",
        "outcome": "Wynik",
        "priority": "Priorytet",
        "createdAt": "Utworzono",
        "status": "Status"
      },
      "searchPlaceholder": "Szukaj reguł…",
      "filter": {
        "chain": "Sieć",
        "store": "Sklep",
        "stage": "Etap",
        "searchStages": "Szukaj etapów…",
        "noStages": "Nie znaleziono etapów"
      },
      "actions": {
        "activate": "Aktywuj",
        "deactivate": "Dezaktywuj"
      },
      "addRuleButton": "Utwórz regułę"
    },
    "stage": {
      "creation": "Tworzenie",
      "visibility": "Widoczność",
      "workability": "Wykonalność"
    },
    "outcome": {
      "allow": "Zezwól",
      "deny": "Odmów"
    },
    "fields": {
      "name": "Nazwa",
      "description": "Opis",
      "scope": "Zakres",
      "stage": "Etap",
      "outcome": "Wynik",
      "priority": "Priorytet",
      "predicate": "Reguła",
      "tickets": "Zgłoszenia",
      "startDate": "Data rozpoczęcia",
      "endDate": "Data zakończenia",
      "status": "Aktywna",
      "createdAt": "Utworzono",
      "updatedAt": "Zaktualizowano"
    },
    "detail": {
      "tabs": {
        "info": "Info",
        "edit": "Edytuj",
        "activity": "Aktywność"
      }
    },
    "edit": {
      "updated": "Reguła „{{name}}” zaktualizowana",
      "predicateInvalid": "Nieprawidłowe wyrażenie CEL",
      "predicateUnknownProperty": "Nierozpoznana właściwość",
      "variables": "Zmienne",
      "allowedValues": "Dozwolone wartości",
      "predicateInvalidValue": "Nieprawidłowa wartość",
      "predicateDecimalExpected": "Oczekiwano wartości dziesiętnej",
      "predicateRuntimeTypeError": "Zakończy się błędem przy ocenie",
      "predicateObjectNotValue": "Obiekt, nie wartość",
      "availableFields": "Dostępne pola",
      "fields": "Pola {{variable}}"
    },
    "dialog": {
      "activateTitle": "Aktywuj regułę",
      "deactivateTitle": "Dezaktywuj regułę",
      "activatePrompt": "Czy na pewno chcesz aktywować",
      "deactivatePrompt": "Czy na pewno chcesz dezaktywować",
      "activateConfirm": "Aktywuj",
      "deactivateConfirm": "Dezaktywuj",
      "deactivateWarning": "Ta reguła nie będzie stosowana przez Octo, dopóki jest nieaktywna.",
      "createTitle": "Utwórz regułę",
      "created": "Reguła „{{name}}” utworzona"
    },
    "form": {
      "chain": "Sieć",
      "store": "Sklep",
      "scopeLabel": "Zakres",
      "selectChain": "Wybierz sieć…",
      "selectStore": "Wybierz sklep…"
    },
    "tools": {
      "menuLabel": "Narzędzia",
      "evaluate": "Oceń reguły"
    },
    "evaluate": {
      "title": "Ocena reguł",
      "contextTitle": "Kontekst oceny",
      "contextHint": "Wybierz typ zadania, aby uruchomić łańcuch. Dodaj produkt i czas, aby ocenić względem nich.",
      "taskType": "Typ zadania",
      "selectTaskType": "Wybierz typ zadania…",
      "searchTaskTypes": "Szukaj typów zadań…",
      "noTaskTypes": "Nie znaleziono typów zadań",
      "evaluatedAt": "Bieżąca data i godzina",
      "product": {
        "upc": "UPC",
        "itemNumber": "Numer artykułu",
        "upcPlaceholder": "UPC produktu",
        "itemNumberPlaceholder": "Numer artykułu"
      },
      "timezoneHint": "Czas jest odczytywany jako lokalny czas sklepu ({{timezone}}). Pozostaw puste, aby użyć teraz.",
      "timezoneHintGeneric": "Czas jest odczytywany jako lokalny czas sklepu. Pozostaw puste, aby użyć teraz.",
      "pickStore": "Wybierz sklep, aby zobaczyć reguły, przez które przechodzi.",
      "running": "Ocenianie…",
      "failed": "Ocena nie powiodła się",
      "noRules": "Żadne reguły nie dotyczą tego sklepu i etapu.",
      "runButton": "Oceń",
      "stoppedHere": "Ocena zatrzymała się tutaj",
      "priorityLabel": "priorytet {{priority}}",
      "noPredicate": "Brak predykatu — zawsze obowiązuje",
      "outOfDateRange": "Poza swoim zakresem dat, ale mimo to oceniana — silnik ignoruje te daty.",
      "outcomeTitle": "Wynik",
      "outcomeNone": "Nieokreślony",
      "scope": {
        "global": "Globalna",
        "chain": "Sieć",
        "store": "Sklep"
      },
      "evaluation": {
        "matched": "Dopasowana",
        "notMatched": "Brak dopasowania",
        "fallback": "Awaryjna",
        "skippedInactive": "Nieaktywna",
        "notReached": "Nieosiągnięta",
        "error": "Błąd",
        "notEvaluated": "Nieoceniona"
      },
      "reason": {
        "ruleMatched": "Zdecydowała reguła „{{rule}}\" — pierwsza, której predykat pasuje.",
        "fallbackRule": "Zdecydowała reguła „{{rule}}\" — bez predykatu, więc obowiązuje zawsze.",
        "implicitFallback": "Żadna reguła nie pasuje. Silnik domyślnie odmawia.",
        "compileError": "Nie udało się skompilować reguł tego etapu, więc żadna nie została uruchomiona.",
        "evaluationError": "Ocena przerwana w trakcie, nie podjęto decyzji.",
        "noRules": "Brak aktywnych reguł dla tego sklepu i etapu — silnik nie ingeruje.",
        "notEvaluated": "Jeszcze nie oceniono. Wybierz typ zadania i naciśnij Oceń."
      },
      "effect": {
        "creation": {
          "allow": "Zadanie zostałoby utworzone.",
          "deny": "Zadanie zostałoby wstrzymane i nigdy nie powstałoby."
        },
        "visibility": {
          "allow": "Zadanie byłoby widoczne w sklepie.",
          "deny": "Zadanie byłoby ukryte w sklepie."
        },
        "workability": {
          "allow": "Zadanie byłoby wykonalne.",
          "deny": "Zadanie nie byłoby wykonalne."
        }
      },
      "debug": {
        "compiledRule": "Skompilowany łańcuch reguł",
        "boundContext": "Powiązany kontekst",
        "empty": "Pusty"
      }
    }
  },
  "devices": {
    "title": "Urządzenia",
    "list": {
      "columns": {
        "id": "ID",
        "name": "Nazwa",
        "store": "Sklep",
        "chain": "Sieć",
        "createdAt": "Utworzono",
        "lastImage": "Ostatni obraz",
        "lastStatus": "Ostatni status",
        "status": "Status"
      },
      "searchPlaceholder": "Szukaj urządzeń...",
      "filter": {
        "chain": "Sieć",
        "store": "Sklep"
      }
    }
  },
  "firmware": {
    "title": "Firmware",
    "list": {
      "columns": {
        "id": "ID",
        "version": "Wersja",
        "versionNum": "Build",
        "deviceType": "Urządzenie",
        "cpuType": "CPU",
        "firmwareType": "Firmware",
        "production": "Produkcja",
        "createdAt": "Utworzono",
        "status": "Status"
      },
      "searchPlaceholder": "Szukaj wersji...",
      "filter": {
        "deviceType": "Typ urządzenia",
        "searchDeviceTypes": "Szukaj typów urządzeń…",
        "noDeviceTypes": "Nie znaleziono typów urządzeń",
        "cpuType": "Typ CPU",
        "searchCpuTypes": "Szukaj typów CPU…",
        "noCpuTypes": "Nie znaleziono typów CPU",
        "production": "Produkcja"
      },
      "addButton": "Utwórz wersję"
    },
    "fields": {
      "versionStr": "Wersja",
      "versionNum": "Numer kompilacji",
      "deviceType": "Typ urządzenia",
      "cpuType": "Typ CPU",
      "fileUri": "URI pliku",
      "md5": "MD5",
      "changeLog": "Dziennik zmian",
      "createdAt": "Utworzono",
      "updatedAt": "Zaktualizowano",
      "file": "Plik firmware"
    },
    "production": {
      "ready": "produkcja",
      "draft": "wersja robocza"
    },
    "actions": {
      "activate": "Aktywuj",
      "deactivate": "Dezaktywuj",
      "markProduction": "Oznacz jako produkcyjną",
      "unmarkProduction": "Usuń oznaczenie produkcyjne"
    },
    "dialog": {
      "activateTitle": "Aktywuj wersję",
      "deactivateTitle": "Dezaktywuj wersję",
      "activatePrompt": "Czy na pewno chcesz aktywować",
      "deactivatePrompt": "Czy na pewno chcesz dezaktywować",
      "deactivateWarning": "Urządzenia nie będą otrzymywać tego oprogramowania, gdy jest nieaktywne.",
      "activateConfirm": "Aktywuj",
      "deactivateConfirm": "Dezaktywuj",
      "markProductionTitle": "Oznacz jako produkcyjną",
      "unmarkProductionTitle": "Usuń oznaczenie produkcyjne",
      "markProductionPrompt": "Oznacz jako produkcyjną",
      "unmarkProductionPrompt": "Usuń oznaczenie produkcyjne z",
      "markProductionConfirm": "Oznacz produkcyjną",
      "unmarkProductionConfirm": "Usuń",
      "createTitle": "Utwórz wersję firmware",
      "created": "Wersja „{{name}}” utworzona",
      "productionLabel": "Produkcyjna",
      "fileHint": "Prześlij plik binarny firmware ({{ext}})",
      "fileDropTitle": "Upuść plik firmware lub kliknij, aby wybrać",
      "cpuPlaceholder": "Wybierz typ CPU",
      "fileHintArchive": "Prześlij archiwum firmware ({{ext}})",
      "createFailed": "Nie udało się utworzyć wersji firmware. Spróbuj ponownie.",
      "versionExists": "Ta wersja już istnieje dla wybranego typu urządzenia",
      "fileRequired": "Wybierz plik firmware do przesłania",
      "buildNumberExists": "Ten numer kompilacji już istnieje dla wybranego typu urządzenia"
    },
    "detail": {
      "tabs": {
        "info": "Info",
        "assignments": "Przypisania"
      }
    },
    "assignments": {
      "empty": "Do tej wersji nie przypisano żadnych sieci, sklepów ani urządzeń.",
      "frozen": "Zamrożone",
      "columns": {
        "scope": "Zakres",
        "target": "Cel",
        "frozen": "Zamrożone",
        "assignedAt": "Przypisano",
        "id": "ID"
      },
      "scope": {
        "device": "Urządzenie",
        "store": "Sklep",
        "chain": "Sieć"
      },
      "searchPlaceholder": "Szukaj przypisań...",
      "searchScopes": "Szukaj zakresów…",
      "noScopes": "Nie znaleziono zakresów"
    }
  },
  "updateAvailable": {
    "message": "Dostępna jest nowa wersja.",
    "reload": "Odśwież"
  }
}
